// import React, { useState, useRef, useEffect } from "react";
// import ReactDOM from "react-dom";
// import styled from "styled-components";

// const TooltipText = styled.div`
//   position: fixed;
// //   background-color: #333;
// //   color: #fff;
//   background-color: #f1f1f1;
//   color: #333;
//   padding: 6px 10px;
//   border-radius: 4px;
//   font-size: 0.8rem;
//   white-space: nowrap;
//   pointer-events: none;
//   opacity: ${({ visible }) => (visible ? 1 : 0)};
//   transition: opacity 0.2s;
//   z-index: 1000;
// `;

// export default function CustomTooltip({ children, content, direction = "top" }) {
//   const [visible, setVisible] = useState(false);
//   const [coords, setCoords] = useState({ top: 0, left: 0 });
//   const wrapperRef = useRef();

//   const showTooltip = () => {
//     const rect = wrapperRef.current.getBoundingClientRect();
//     let top = 0, left = 0;

//     switch (direction) {
//       case "top":
//         top = rect.top - 6; 
//         left = rect.left + rect.width / 2;
//         break;
//       case "bottom":
//         top = rect.bottom + 6;
//         left = rect.left + rect.width / 2;
//         break;
//       case "left":
//         top = rect.top + rect.height / 2;
//         left = rect.left - 6;
//         break;
//       case "right":
//         top = rect.top + rect.height / 2;
//         left = rect.right + 6;
//         break;
//       default:
//         top = rect.top - 6; 
//         left = rect.left + rect.width / 2;
//     }

//     setCoords({ top, left });
//     setVisible(true);
//   };

//   const hideTooltip = () => setVisible(false);

//   return (
//     <div ref={wrapperRef} onMouseEnter={showTooltip} onMouseLeave={hideTooltip} style={{ display: "inline-block" }}>
//       {children}
//       {ReactDOM.createPortal(
//         <TooltipText
//           visible={visible}
//           style={{
//             top: `${coords.top}px`,
//             left: `${coords.left}px`,
//             transform: direction === "top" || direction === "bottom" ? "translateX(-50%)" : "translateY(-50%)"
//           }}
//         >
//           {content}
//         </TooltipText>,
//         document.body
//       )}
//     </div>
//   );
// }



import React, { useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

const TooltipText = styled.div`
  position: fixed;
  background-color:rgb(126, 154, 184);   /* Banner-inspired purple */
  color: #fff;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 600;
  pointer-events: none;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.15s, transform 0.1s;
  white-space: nowrap;
  z-index: 1000;
`;

export default function CustomTooltip({ children, content }) {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    setCoords({ x: e.clientX + 10, y: e.clientY + 10 }); // offset a bit from cursor
  };

  const handleMouseEnter = () => setVisible(true);
  const handleMouseLeave = () => setVisible(false);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ display: "inline-block" }}
    >
      {children}

      {ReactDOM.createPortal(
        <TooltipText
          visible={visible}
          style={{
            top: coords.y + "px",
            left: coords.x + "px",
            transform: "translate(0, 0)",
          }}
        >
          {content}
        </TooltipText>,
        document.body
      )}
    </div>
  );
}
